import { ShieldCheck, Camera, Truck, Clock, Award, HeartHandshake } from "lucide-react";

const reasons = [
  { icon: Camera,        title: "Foto antes da entrega",     desc: "Você aprova o arranjo pronto pelo WhatsApp antes da saída do nosso entregador." },
  { icon: Clock,         title: "Atendimento 24 horas",      desc: "Atendemos pedidos de última hora 24h por dia, inclusive feriados e madrugadas." },
  { icon: Truck,         title: "Entrega grátis",            desc: "Frete grátis para todos os cemitérios e velórios do município do Rio de Janeiro." },
  { icon: Award,         title: "5.0 estrelas no Google",    desc: "Mais de 500 famílias atendidas em 2025 com nota máxima nas avaliações públicas." },
  { icon: HeartHandshake, title: "Atendimento humanizado",   desc: "Falamos com você com respeito e empatia — sem scripts, sem espera, sem robô." },
  { icon: ShieldCheck,   title: "Faixa de homenagem grátis", desc: "Mensagem personalizada na faixa de homenagem inclusa em todos os modelos, sem custo." },
];

export const WhyChoose = () => {
  return (
    <section className="py-20 md:py-28 bg-[#F4F2EC]">
      <div className="container-wide">
        <div className="max-w-2xl">
          <span className="overline">Por que escolher</span>
          <h2 className="font-serif text-4xl md:text-5xl text-[#2D4A3E] leading-tight mt-3">
            Tudo o que importa em um momento delicado
          </h2>
          <p className="mt-4 text-[#5C5C5C] leading-relaxed">
            Mais de uma década entregando coroas com a seriedade que cada despedida merece.
            Confiabilidade, agilidade e respeito em cada detalhe.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {reasons.map((r) => (
            <article key={r.title} className="bg-white border border-[#E5E3DB] rounded-2xl p-6 hover:border-[#2D4A3E] transition-all duration-500 hover:-translate-y-1">
              <div className="h-11 w-11 rounded-xl bg-[#2D4A3E]/10 flex items-center justify-center mb-5">
                <r.icon className="h-5 w-5 text-[#2D4A3E]" strokeWidth={1.5} />
              </div>
              <h3 className="font-serif text-xl text-[#2D4A3E]">{r.title}</h3>
              <p className="mt-2 text-sm text-[#5C5C5C] leading-relaxed">{r.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
